import { Injectable } from '@angular/core';

import { ChargeForWidget } from './change-item-entites';

@Injectable()
export class ChargeItemService {
	private _chargeToPay: ChargeForWidget;
	public get chargeToPay(): ChargeForWidget {
		return this._chargeToPay;
	}
	public set chargeToPay(charge: ChargeForWidget) {
		this._chargeToPay = charge;
	}
}
